import { Map } from 'immutable';
import {
	CLOSE_MODAL,
	DESTROY_CUSTOMER_ID_AND_RESULT_CODE,
	OPEN_MODAL,
	SET_MODAL_MESSAGE,
	SET_MODAL_TITLE,
	SET_CUSTOMER_ID,
	SET_RESULT_CODE,
	SET_PREVIOUS_APPLICATION_VALUES,
} from './constants';

export const initialState = Map({
	customerId: '',
	modalOpen: false,
	modalMessage: '',
	modalTitle: '',
	resultCode: null,
});

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case CLOSE_MODAL:
			return state.merge({
				modalOpen: false,
			});
		case DESTROY_CUSTOMER_ID_AND_RESULT_CODE: {
			return state.set('customerId', '').set('resultCode', null);
		}
		case OPEN_MODAL:
			return state.merge({
				modalOpen: true,
			});
		case SET_CUSTOMER_ID:
			return state.merge({
				customerId: action.customerId,
			});
		case SET_MODAL_MESSAGE:
			return state.merge({
				modalMessage: action.message,
			});
		case SET_MODAL_TITLE:
			return state.merge({
				modalTitle: action.title,
			});
		case SET_RESULT_CODE:
			return state.merge({
				resultCode: action.resultCode,
			});
		case SET_PREVIOUS_APPLICATION_VALUES:
			return state.merge({
				previousApplicationValues: action.previousApplicationValues,
			})
		default:
			return state;
	}
};

export default reducer;
